<template>
  <section class="columns pa-section pa-section-front-action-buttons">
    <div class="column">
      <PaLoginButton @click.prevent="handleClickLogin" />
    </div>

    <div class="column">
      <PaRegistrationButton
       class="registration"
       @click.prevent="handleClickRegistration"
      />
    </div>
  </section>
</template>

<script>
import PaLoginButton from '@/components/FrontParts/PaFrontActionButtons/Images/login_button.svg?inlineF'
import PaRegistrationButton from '@/components/FrontParts/PaFrontActionButtons/Images/registration_button.svg?inlineN'
// import PaRegistrationButton from '@/components/FrontParts/PaFrontActionButtons/Images/new_registration_button.svg?inlineN'

export default {
  components : {
    PaLoginButton,
    PaRegistrationButton
  },

  methods : {
    handleClickLogin(){
      this.$parent.$emit('openLoginModal');
    },

    handleClickRegistration(){
      this.$router.push({
        name    : 'registration.notice',
      });
      // const newUrlQuery = Object.assign({}, this.$route.query);

      // newUrlQuery['is_open_registration_test_modal'] = 'yes';

      // this.$router.push({
      //   name    : this.$route.name,
      //   params  : this.$route.params,
      //   query   : newUrlQuery
      // });
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

section.pa-section{
  &-front-action-buttons{
    margin:.75rem 0 0 0;
    padding:0;
    
    @include from($tablet) {
      max-width: 840px;
      margin:1.6rem auto;
    }

    div.column{
      padding:0.4rem;
      text-align: center;

      svg{
        width:95%;

        &.registration{
          .cls-2{
            fill: #969595;
          }

          .cls-3{
            fill: #af6d8b;
          }
          // .a{fill:#531223;}
          // .b{fill:#771e39;}
          // .c{fill:#969595;}
          // .d{fill:#af6d8b;}
          // .e{fill:#893658;}
        }
      }
    }
  }
}
</style>